import Urls from "../api/Configuration";
import { ContactFormRequest } from "../api/dtos/contactForm/ContactFormRequest";
import EmptyApiResponse from "../api/dtos/EmptyApiResponse";
import ServiceLocator from "./ServiceLocator";

export default class ContactFormService {
  public SendContactForm(request: ContactFormRequest): Promise<EmptyApiResponse> {
    return ServiceLocator.ApiClient.Post<EmptyApiResponse>(Urls.PUBLIC_CONTACT, request);
  }
}
